import styled, { css } from 'styled-components';

import { ReactComponent as ArrowIcon } from './arrow.svg';

export const Wrapper = styled.div<{ $direction?: 'up' | 'down' }>`
    display: flex;
    gap: 2px;

    color: #2eff50;
    font-size: 10px;
    font-weight: 700;
    line-height: 100%;
    font-variant-numeric: tabular-nums;

    ${({ $direction }) =>
        $direction === 'down' &&
        css`
            color: #ff0000;
        `}
`;

export const Icon = styled(ArrowIcon)<{ $direction?: 'up' | 'down' }>`
    ${({ $direction }) =>
        $direction === 'down' &&
        css`
            transform: rotate(180deg) translateY(-1px);
        `}
`;
